export enum CreateSetStep {
  Definition = 1,
  ReportsFromSets = 2
}
